import React from 'react'

import { APP_SESSION } from '@zet/constants'
import { Stack } from '@zet/design-system/layout'
import NetworkIssue from '@zet/design-system/svg/NetworkIssue'
import { i18n } from '@zet/localization'
import { reloadAsync } from 'expo-updates'

import { ErrorScreenLayout } from './components/errorScreenLayout'

export const NetworkIssueScreen = () => {
  const onPress = async () => {
    APP_SESSION.setReloadType('ERROR_SCREEN')
    await reloadAsync()
  }

  return (
    <Stack>
      <ErrorScreenLayout
        ErrorIconComponent={NetworkIssue}
        title={i18n.t('errorScreens.networkIssue')}
        description={i18n.t('errorScreens.networkIssueDesc')}
        buttonTitle={i18n.t('errorScreens.refresh')}
        buttonOnPress={onPress}
      />
    </Stack>
  )
}
